export const getAllVideos = (state) => {
  return state.videos.videoIds.map((id) => state.videos.videosById[id]);
};

export const getFeaturedVideos = (state) => {
  return state.videos.videoIds.slice(0, 2).map((id) => state.videos.videosById[id]);
};

export const getVideoById = (state, id) => {
  return state.videos.videosById[id];
};

export const getPopupVideoId = (state) => {
  return state.videos.popupVideoId;
};
